function initPageChildrenNavigation(){

    (function($){

        $('#page_children_navigation').on('change', function(){
            location.href = $(this).val();
        });

    })(jQuery);
}

function initCountrySelect(){

    (function($){

        $('.wcpbc-widget-country-selecting .country').niceSelect();

    })(jQuery);
}

function initFooterNavigation() {

    (function($){

        $('.site-footer__column-arrow').on('click', function(){

            var $this = $(this);

            $this.toggleClass('site-footer__column-arrow--open');
            $this.parent().parent().find('.site-footer__column-text').toggleClass('site-footer__column-text--open');
            $this.parent().parent().find('.site-footer__list').toggleClass('site-footer__list--open');

        });

    })(jQuery);

}


if (jQuery('select').data('select2')) {
   jQuery('select').select2('destroy');
 }
